export default __webpack_public_path__ + "static/TautanSudahTidakTersedia-bad76ddd84cca266a678ce6618eebe91.png";